import { maxValue } from '../utils/maxValue';
import { validateLength } from '../utils/formUtils';
import { unTriggeredRuleResult } from '../utils';

/**
 * Used to validate the length of the input string value.
 * The validation includes all the characters in the string.
 * @param params
 * @param value
 */
export const maxLengthRule = (params, value) => {
  if (typeof value !== 'string') {
    return unTriggeredRuleResult;
  }
  const max = maxValue(params.masking, params.maxLength);
  const results = validateLength(value, max, 'greaterThan');
  return {
    triggered: results,
    validationState: {
      isValid: !results,
      message: results ? params.customErrorMessages?.exceedsMaxLength || `'${value}' exceeds character limit of '${max}'` : undefined,
      type: results ? 'error' : undefined,
      messageKey: 'exceedsMaxLength'
    }
  };
};